import { FormProvider, useForm, useWatch } from "react-hook-form";
import {
  Step1Form,
  Step2Form,
  Step3Form,
  Step4Form,
  Step5Form,
  Step6Form,
} from "../../application_form/components";
import {
  Checkbox,
  FormGroup,
  SubmitButton,
} from "../../../../@coherent/react-hook-form";
import React from "react";
import { Step2aForm } from "../../application_form/components/Step2a";

export const ApplicationForm = ({ defaultValues, onSubmit }) => {
  const methods = useForm({
    defaultValues,
    mode: "onBlur",
    shouldUnregister: true,
  });
  const { handleSubmit } = methods;

  const isYoungHelper =
    useWatch({
      control: methods.control,
      name: "young_helper",
    }) === "Yes";

  let steps;
  if (isYoungHelper) {
    steps = [Step1Form, Step2aForm, Step5Form, Step6Form];
  } else {
    steps = [Step1Form, Step2Form, Step3Form, Step4Form, Step5Form, Step6Form];
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset>
          {steps.map((Step, i) => (
            <React.Fragment key={i}>
              <Step required={false} />
              <hr />
            </React.Fragment>
          ))}
          <hr />
          <FormGroup
            name="submit"
            check
            label="Mark this application as submitted"
          >
            <Checkbox
              className="form-check-input"
              name="submit"
              defaultValue={!!defaultValues.submitted}
            />
          </FormGroup>
          <div className="tw-flex tw-justify-end">
            <SubmitButton>Submit</SubmitButton>
          </div>
        </fieldset>
      </form>
    </FormProvider>
  );
};
